jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);


         
         
	   });

  
  $('.toggle section .category-label').click(function(){
    let toggle = $(this).parent();
    let toggle_content = toggle.find('.toggle-content');
      if(toggle.hasClass('active')){
        toggle.find('.toggle-content').hide();
        toggle.find('.category-icon').text(' +');
        toggle.removeClass('active');
      }else{
           toggle.find('.toggle-content').show();
          toggle.find('.category-icon').text(' -');
            toggle.addClass('active');
          
      }
         
  })

  $('.toggle-content').hide();

  let textarray = [];
  
  $('.toggle li a').map(function(){
    
    let currentUrl = location.pathname;
    
    if($(this).attr('href') === currentUrl){
      let activated = $(this).parent().parent().parent().parent();
      activated.addClass('active');
      $(this).addClass('text-underline');

      if($('.toggle').hasClass('active')){
        
           $(this).parent().parent().parent().show();
          $(this).parent().parent().parent().parent().find('.category-icon').text(' -');
            
      }else{
        
      }
      
    }
  });

  $('.t4s-truncate').addClass('shop-cat')




  

});

